import React, { type ImgHTMLAttributes } from "react";
import steadyArt from "../assets/spice-1-steady.svg";
import juicyArt from "../assets/spice-2-juicy.svg";
import spicyArt from "../assets/spice-3-spicy.svg";
import bigSwingArt from "../assets/spice-4-big-swing.svg";
import hailMaryArt from "../assets/spice-5-hail-mary.svg";
import type { SpiceLevel } from "../util/constants";

const artForLevel: Record<SpiceLevel, string> = {
  1: steadyArt,
  2: juicyArt,
  3: spicyArt,
  4: bigSwingArt,
  5: hailMaryArt,
};

type SpiceIconProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt"
> & {
  level: SpiceLevel;
};

export const SpiceIcon = ({ level, ...props }: SpiceIconProps) => (
  <img src={artForLevel[level]} alt="" {...props} />
);
